import { useFeatureValue } from '@growthbook/growthbook-react';

import { GB_FEATURE_KEYS } from '~/services/abTests/features';
import {
  ComplianceExperience,
  ComplianceExperienceId,
  getComplianceExperience,
} from '~/services/compliance/experience';

export const useComplianceExperience = (): ComplianceExperience => {
  const value = useFeatureValue(
    GB_FEATURE_KEYS.COMPLIANCE,
    ComplianceExperienceId.V2,
  );

  return getComplianceExperience(value);
};
